import { IPropertiesOfPatchChangesForDish, TPortionSelectionMode, TPriceStrategy } from 'types';

export const properties: IPropertiesOfPatchChangesForDish[] = [
	{ id: 'activation', name: 'activation' },
	{ id: 'deactivation', name: 'deactivation' },
	{ id: 'price', name: 'price' },
	{ id: 'taxRate', name: 'taxRate' },
	{ id: 'openPrice', name: 'openPrice' },
	{ id: 'isDisabled', name: 'isDisabled' },
	{ id: 'comments', name: 'comments' },
	{ id: 'isFiscalized', name: 'isFiscalized' },
	{ id: 'protectFromSync', name: 'protectFromSync' },
];

export const priceStrategies: { id: TPriceStrategy; name: string; disabled?: boolean }[] = [
	{ id: 'Undefined', name: 'priceStrategyUndefinedLabel', disabled: true },
	{ id: 'Override', name: 'priceStrategyOverrideLabel' },
	{ id: 'Additive', name: 'priceStrategyAdditiveLabel' },
];

export const defaultPriceStrategy: TPriceStrategy = 'Additive';

export const portionSelectionModes: { id: TPortionSelectionMode; name: string }[] = [
	{ id: 'Required', name: 'portionSelectionRequiredLabel' },
	{ id: 'Optional', name: 'portionSelectionOptionalLabel' },
];

export const defaultPortionSelectionMode: TPortionSelectionMode = 'Required';
